'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var cp = require('./cp.js');
var rm = require('./rm.js');
var mergeOpts = require('merge-options');
var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

const mergeOptions = mergeOpts__default["default"].bind({ ignoreUndefined: true });
const defaultOptions = {
  parents: false,
  flush: true,
  cidVersion: 0,
  hashAlg: 'sha2-256',
  shardSplitThreshold: 1000
};
function createMv(context) {
  async function mfsMv(from, to, options = {}) {
    const opts = mergeOptions(defaultOptions, options);
    await cp.createCp(context)(from, to, opts);
    await rm.createRm(context)(from, {
      ...opts,
      recursive: true
    });
  }
  return withTimeoutOption.withTimeoutOption(mfsMv);
}

exports.createMv = createMv;
